// extracted by mini-css-extract-plugin
export var alternate = "_14-h";
export var black = "_14-3";
export var blue = "_14-d";
export var blueLight = "_14-c";
export var brand = "_14-7";
export var error = "_14-9";
export var gray = "_14-6";
export var grayBlue = "_14-b";
export var iconWrapper = "_14-4";
export var indigo = "_14-e";
export var orange = "_14-g";
export var pink = "_14-f";
export var primary = "_14-0";
export var purple = "_14-8";
export var success = "_14-5";
export var warning = "_14-a";
export var white = "_14-1";
export var whiteSuccess = "_14-2";